import API from '@/api';
import isEmpty from 'lodash/isEmpty';

/**
 * Shared logic for documents
 */
export default {
  data() {
    return {};
  },
  computed: {
    allExtractedDocuments() {
      if (this.currentQuestionnaire.extracted_documents.length === 0) {
        return [];
      } else {
        return this.currentQuestionnaire.extracted_documents;
      }
    },
  },
  methods: {
    findExtractedDocument(document) {
      let extractedDocument = this.allExtractedDocuments.find(d =>
        d.source.toLowerCase().includes(document.toLowerCase()),
      );

      if (extractedDocument) {
        return extractedDocument;
      } else {
        return null;
      }
    },
    parentDocuments() {
      const filteredDocs = this.allExtractedDocuments.filter(
        d =>
          !d.parent_document_id &&
          d.source !== '' &&
          d.source !== 'Questionnaire',
      );

      return filteredDocs.map(doc => {
        const exportedDoc = this.exportedDocs
          ? this.exportedDocs.find(exported =>
              doc.source.includes(exported.document.toLowerCase()),
            )
          : null;
        return {
          ...doc,
          exportedDate: exportedDoc ? exportedDoc.created_at : null,
        };
      });
    },
    childDocuments(parentDocument) {
      return this.allExtractedDocuments.filter(
        d => d.parent_document_id === parentDocument.id,
      );
    },
    childrenSinglePage(parentDocument) {
      if (
        this.allExtractedDocuments.filter(
          d => d.parent_document_id === parentDocument.id,
        ).length === 1
      ) {
        let onlyChild = this.allExtractedDocuments.find(
          d =>
            d.parent_document_id === parentDocument.id && d.form_name_verified,
        );
        return !!(onlyChild && !onlyChild.source.includes('(page '));
      } else {
        return false;
      }
    },
  },
};
